$(function () {
  /* ========== ハンバーガーメニュー ========== */
  $('#hamburger').on('click', function () {
    $('.icon, .header').toggleClass('opened');
    $('.nav_sp').fadeToggle(500);
    $('body').toggleClass('noscroll');
    $('.hamburger_wrap').toggleClass('scroll');
  });

  $('#nav_sp .nav_item').on('click', function () {
    $('#hamburger').trigger('click');
  });

  /* ========== スクロール時フェードイン ========== */
  function scroll_effect() {
    $('.fadein_pc, .fadein_sp').each(function () {
      const elemPos = $(this).offset().top;
      const scroll = $(window).scrollTop();
      const windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('active');
        $('.header').removeClass('appear');
      }
    });
  }
  scroll_effect();
  $(window).on('scroll', scroll_effect);

  /* ========== Key Visual Animation ========== */
  $(window).one('load', function () {
    $('body, .content').addClass('appear');
    $('.header').addClass('hide');

    $('.splashbg').on('animationend', function () {
      $('.content').addClass('appear');
    });

    $('.content').one('animationend', function () {
      $('.kv_ttl, .header').addClass('appear');
    });
  });

  /* ========== ヘッダースクロール挙動 ========== */
  let startPos = 0;
  $(window).on('scroll', function () {
    const winScrollTop = $(this).scrollTop();

    if (winScrollTop >= startPos && winScrollTop >= 70) {
      $('header').removeClass('appear');
      $('.header').addClass('hide');
      $('.fixed_title').addClass('headerhide');
    } else {
      $('.header').removeClass('hide');
      $('.fixed_title').removeClass('headerhide');
      $('header').removeClass('appear');
    }

    startPos = winScrollTop;
  });

  /* ========== メニューリンククリック後のアニメーション ========== */
  $('.menu_tag').on('click', function () {
    $('.header').addClass('hide');
    setTimeout(() => {
      $('.header').removeClass('hide');
    }, 1000);
  });

  /* ========== ページ内リンクスムーススクロール ========== */
  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const target = href === '#' || href === '' ? $('html') : $(href);
    const position = target.offset().top;
    $('html, body').animate({ scrollTop: position }, 400, 'swing');
    $('.header').removeClass('hide');
  });
});

